import { useHistory } from "react-router-dom"
import { Link } from '@material-ui/core';
import { IState } from "views/Tickets/TicketsContext";


let Clickable = (prop: { value: number, type?: string, status?: string, supplier: string }) => {
    let history = useHistory<IState>()
    return (
        <>
            {prop.value === 0 && '-'}
            {prop.value > 0 &&
                <Link
                    component="button"
                    onClick={() => history.push(
                        history.location.pathname,
                        {
                            search: {
                                userGroup: "",
                                customerStatus: [],
                                supplier: prop.supplier,
                                pageNr: 0,
                                pageSize: 20,
                                fullText: "",
                                assignee: '',
                                csAssignee: '',
                                reporter: '',
                                reporterName: '',
                                status: prop.status ? [prop.status] : [],
                                type: prop.type || "",
                                lastUpdatedOnFrom: null,
                                customerOrder: '',
                                productSKU: '',
                                customerM3Id: '',
                                customerName: '',
                                serviceOrder: '',
                                serialNumber: ''
                            },
                            queue: "",
                            supplier: ""
                        }
                    )}
                >
                    {prop.value}
                </Link>
            }
        </>
    )
}
export default Clickable